// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Table_wrapper__1soP7"};